import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./Servicespage.scss";
import PageBanner from "../layouts/PageBanner";
import aboutServices from "../../assets/about-hero.jpg";

const API = "https://api.ainfotech.com.np";

const ServiceDetail = () => {
  const { key: slug } = useParams(); // treat :key as slug
  const navigate = useNavigate();

  const [item, setItem] = useState(null);
  const [all, setAll] = useState([]);

  // Load current service
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/services/${slug}`);
        if (res.status === 404) { setItem(null); return; }
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || "Failed to load service");
        setItem(data);
        window.scrollTo(0, 0);
      } catch (e) {
        console.error(e);
        setItem(null);
      }
    })();
  }, [slug]);

  // Load list for sidebar
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/services?status=published&page=1&limit=50`);
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || "Failed to load services");
        setAll(Array.isArray(data.items) ? data.items : []);
      } catch (e) {
        console.error(e);
        setAll([]);
      }
    })();
  }, []);

  const others = useMemo(
    () => all.filter((x) => x.slug !== slug).slice(0, 6),
    [all, slug]
  );

  if (!item) {
    return (
      <div className="container py-5">
        <h3 className="mb-2">Service not found</h3>
        <p className="text-muted">The service you’re looking for may have been moved or renamed.</p>
        <Link to="/servicespage" className="btn btn-outline-secondary">Back to Services</Link>
      </div>
    );
  }

  const cover = item.cover_image ? `${API}${item.cover_image}` : undefined;

  return (
    <div className="avena-services-page">
      <div className="avena-news">
        <PageBanner
          title={item.title}
          bg={aboutServices}
          crumbs={[
            { label: "Home", href: "/" },
            { label: "Services", href: "/servicespage" },
            { label: item.title },
          ]}
        />
      </div>

      <section className="svc-detail">
        <div className="container">
          <div className="row g-4">
            {/* LEFT: Title + Description */}
            <div className="col-12 col-lg-8">
              <article className="svc-article">
                <h1 className="svc-detail__title">{item.title}</h1>

                <div
                  className="svc-hero"
                  style={{ backgroundImage: cover ? `url(${cover})` : undefined }}
                  role="img"
                  aria-label={item.title}
                />

                <div className="svc-content">
                 
                  <div
                    className="svc-rich"
                    dangerouslySetInnerHTML={{ __html: item.content_html || "" }}
                  />

                 
                </div>
              </article>
            </div>

            {/* RIGHT: Sidebar — other services */}
            <div className="col-12 col-lg-4">
              <aside className="svc-sidebar">
                <div className="svc-sidecard">
                  <h5 className="svc-sidecard__title">Other Services</h5>
                  <ul className="svc-side-list">
                    {others.map((o) => {
                      const thumb = o.cover_image ? `${API}${o.cover_image}` : undefined;
                      return (
                        <li key={o.id}>
                          <button
                            type="button"
                            className="svc-side-item"
                            onClick={() => navigate(`/services/${o.slug}`)}
                          >
                            <div
                              className="svc-side-thumb"
                              style={{ backgroundImage: thumb ? `url(${thumb})` : undefined }}
                            />
                            <span className="svc-side-name">{o.title}</span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                <Link to="/servicespage" className="svc-backlink">← Back to Services</Link>
              </aside>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
